var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-preview panel mt-3 pl-2 pr-2",domProps:{"innerHTML":_vm._s(_vm.previewHTML)}})}
var staticRenderFns = []

export { render, staticRenderFns }